import keycloak from '../keycloak';
import { jwtDecode } from 'jwt-decode';
import SvgColor from '../../src/components/svg-color/SvgColor';

// return the user data from the session storage
export const getUser = () => {
  const userStr = sessionStorage.getItem('user');
  if (userStr) return JSON.parse(userStr);
  return null;
};
export const getFullname = () => {
  return sessionStorage.getItem('fullname');
};
// return the token from the session storage
export const getToken = () => {
  return sessionStorage.getItem('token') || null;
};
export const getRefreshToken = () => {
  return sessionStorage.getItem('refreshToken') || null;
};
export const getAcl = () => {
  return sessionStorage.getItem('acl') || null;
};
export const getAclMenu = (namaMenu) => {
  const jsonString = sessionStorage?.getItem('acl') || '[]';
  const jsonArray = JSON?.parse(jsonString);
  const filteredArray = jsonArray?.filter((item) => item.nama_menu === namaMenu);
  return filteredArray[0] || [];
};
export const getRole = () => {
  const token = keycloak.token;
  let roles = null;

  if (token && typeof token === 'string') {
    const decoded = jwtDecode(token);
    roles = decoded?.resource_access?.smartshield?.roles?.[0];

    // console.log(roles);
  } else {
    // console.log('Invalid token or token is not available');
  }

  return roles;
};
export const getExpired = () => {
  return sessionStorage.getItem('expired') - 1000 || null;
};

export const fetchLog = async (fakeDataUrl) => {
  const postData = {
    refresh_token: keycloak.refreshToken,
  };
  // console.log('Post Data:', postData);
  try {
    const response = await fetch(fakeDataUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${keycloak.token}`,
      },
      body: JSON.stringify(postData),
    });
    const data = await response.json();
    // console.log('Fetched data:', data);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};
// remove the token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.clear();
  fetch(
    `${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/logout?id_token_hint=${keycloak.idToken}&post_logout_redirect_uri=${window.location.origin}`
  ).then(async () => {
    keycloak.login();
    // window.location.href = `${window.location.origin}`;
  });
};

// set the token and user from the session storage
export const setUserSession = (token, refshtoken, user, role, fullname) => {
  sessionStorage.removeItem('acl');
  sessionStorage.setItem('refreshToken', refshtoken);
  sessionStorage.setItem('token', token);
  sessionStorage.setItem('user', JSON.stringify(user));
  getMenuAccess();
  sessionStorage.setItem('role', role);
  sessionStorage.setItem('fullname', fullname);
};
export const setRefreshUserSession = (accesToken, refreshToken, expired) => {
  // keycloak
  //   .updateToken(70)
  //   .then((refreshed) => {
  //     if (refreshed) {
  //       console.debug('Token refreshed' + refreshed);
  //     } else {
  //       console.warn(
  //         'Token not refreshed, valid for ' +
  //           Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) +
  //           ' seconds'
  //       );
  //     }
  //   })
  //   .catch(() => {
  //     console.error('Failed to refresh the token, or the session has expired');
  //   });
  sessionStorage.setItem('expired', Math.floor(Date.now() / 1000) + expired);
  sessionStorage.setItem('token', accesToken);
  sessionStorage.setItem('refreshToken', refreshToken);
};

export const getMenuAccess = () => {
  fetch(window.REACT_APP_API_PURE + 'user/permissions', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      const outputArray = data?.map((item) => ({
        nama_menu: item.resourceName,
        create: item?.scopes?.includes('create'),
        read: item?.scopes?.includes('read'),
        update: item?.scopes?.includes('update'),
        delete: item?.scopes?.includes('delete'),
        process: item?.scopes?.includes('process'),
        download: item?.scopes?.includes('download'),
        verify: item?.scopes?.includes('verify'),
      }));
      sessionStorage.setItem('acl', JSON.stringify(outputArray));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const ListMenu = () => {
  const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;
  return [
    {
      title: 'Dashboard',
      path: '/dashboard/app',
      icon: icon('ic_analytics'),
      namaroute: 'dashboard',
    },
    {
      title: 'Dataset Map',
      path: '/dashboard/dataset',
      icon: icon('ic_rule'),
      namaroute: 'data_set',
    },
    {
      title: 'Alerts',
      path: '/dashboard/alert',
      icon: icon('ic_report'),
      namaroute: 'alert',
    },
    {
      title: 'Calendar',
      path: '/dashboard/calendar',
      icon: icon('ic_calendar'),
      namaroute: 'calendar',
    },
    {
      title: 'Information',
      path: '/dashboard/information',
      icon: icon('ic_information'),
      namaroute: 'information',
    },
    {
      title: 'About',
      path: '/dashboard/about',
      icon: icon('ic_information'),
      namaroute: 'about',
    },
    {
      title: 'Reports',
      path: '/dashboard/report',
      icon: icon('ic_rule'),
      namaroute: 'report',
    },
    {
      title: 'Actions',
      path: '/dashboard/action',
      icon: icon('ic_alert'),
      namaroute: 'action',
    },
    {
      title: 'Users',
      path: '/dashboard/user',
      icon: icon('ic_user'),
      namaroute: 'user',
    },
    {
      title: 'Activity Log',
      path: '/dashboard/activitylogs',
      icon: icon('ic_activity'),
      namaroute: 'activity',
    },
    {
      title: 'Logout',
      path: '/login',
      icon: icon('ic_logout'),
      namaroute: 'logout',
    },
  ];
};
